exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.heading span.h-line {\n  display: inline-block;\n  border-top: 0.3rem solid;\n  border-bottom: 0.3rem solid;\n  border-radius: 0.6rem;\n  width: 100%;\n}\ndiv.heading div.metric-glossary div.VueTables {\n  background-color: white;\n}", ""]);

// exports
